import React, { Component } from "react";
import PropTypes from "prop-types";
import cloneDeep from "lodash/cloneDeep";
import { Form, Formik } from "formik";
import * as Yup from "yup";

import InlineError from "core/components/common/message/InlineError";
import Tabs, { ErrorSection, Tab } from "core/components/common/tabs/Tabs";
import Loading from "components/common/loading/Loading";
import GroupBasicFields, { getBasicInitialValues, getBasicYupSchema } from "./basic/GroupBasicFields";

const topLevelVariables = [
	"name"
];

const PlaygroundGroupSettingsFormMessages = ({ error }) => {
	if (error) {
		return (
			<InlineError>
				<p>There was an error processing your request, please try again.</p>
			</InlineError>
		);
	}

	return "";
};

const PlaygroundGroupSettingsFormSchema = Yup.object().shape({
	...getBasicYupSchema()
});

const applyModelToForm = (model) => {
	const form = {};

	const cloneModel = cloneDeep(model);

	// Copy top level
	topLevelVariables.forEach(v => {
		const val = cloneModel[v];
		if (val !== undefined && val !== null) {
			form[v] = val;
		}
	});

	// Copy settings
	if (cloneModel.settings) {
		Object.keys(cloneModel.settings).forEach(fk => {
			form[fk] = cloneModel.settings[fk];
		});
	}

	return form;
};

const applyFormToModel = (form, model) => {
	const cloneForm = cloneDeep(form);
	const newModel = cloneDeep(model);

	// Copy top level
	topLevelVariables.forEach(v => {
		if (cloneForm[v] !== undefined && cloneForm[v] !== null) {
			newModel[v] = cloneForm[v];
		}

		delete (cloneForm[v]);
	});

	// Copy settings
	if (!newModel.settings) {
		newModel.settings = {};
	}

	Object.keys(cloneForm).forEach(fk => {
		newModel.settings[fk] = cloneForm[fk];
	});

	return newModel;
};

export class PlaygroundGroupSettingsForm extends Component {
	render () {
		let { model, onSubmit, buttonBgColor, buttonFontColor, buttonLabel } = this.props;
		if (!model) {
			model = {};
		}
		if (!buttonLabel) {
			buttonLabel = "Save";
		}
		const loading = model.loading;
		const error = model.error;

		const formData = applyModelToForm(model);

		const onSubmitAdaptor = (form) => {
			return onSubmit(applyFormToModel(form, model));
		};

		return (
			<Formik
				onSubmit={onSubmitAdaptor}
				initialValues={{
					...getBasicInitialValues(formData)
				}}
				validationSchema={PlaygroundGroupSettingsFormSchema}
			>
				{({ errors, touched, ...props }) => (
					<Form className="up-form with-tabs">
						<section className="modal-card-body">
							{loading
								? <Loading/>
								: (
									<>
										<Tabs errors={errors} touched={touched} borderColor={buttonBgColor} {...props}>
											<ErrorSection>
												<PlaygroundGroupSettingsFormMessages error={error}/>
											</ErrorSection>
											<Tab id="basic" title="Basic" fields={["name", "color"]}>
												<GroupBasicFields errors={errors} touched={touched} {...props} />
											</Tab>
										</Tabs>
									</>
								)}
						</section>
						<footer className="modal-card-foot">
							<button
								type="submit" className="button is-primary" disabled={loading} style={{
								backgroundColor: buttonBgColor,
								color: buttonFontColor
							}}
							>{buttonLabel}
							</button>
						</footer>
					</Form>
				)}
			</Formik>
		);
	}
}

PlaygroundGroupSettingsForm.propTypes = {
	model: PropTypes.object.isRequired,
	onSubmit: PropTypes.func.isRequired,
	buttonBgColor: PropTypes.string.isRequired,
	buttonFontColor: PropTypes.string.isRequired
};

export default PlaygroundGroupSettingsForm;
